var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import StretchRow from '../components/StretchRow';
import cxs from 'cxs';
import moment from 'moment';
var styles = {
    container: cxs({
        marginTop: '16px',
        overflowX: 'auto',
    }),
    table: cxs({
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    }),
    headerRow: cxs({
        backgroundColor: '#f8f9fa',
    }),
    experienceHeader: cxs({
        width: '200px',
        minWidth: '200px',
        padding: '10px 12px',
        borderBottom: '2px solid #dee2e6',
        fontWeight: 600,
        fontSize: '0.85rem',
        color: '#495057',
        textAlign: 'left',
        position: 'sticky',
        left: 0,
        backgroundColor: '#f8f9fa',
        zIndex: 10,
    }),
    dayHeader: cxs({
        padding: '10px 8px',
        borderBottom: '2px solid #dee2e6',
        fontWeight: 600,
        fontSize: '0.85rem',
        color: '#495057',
        textAlign: 'center',
        minWidth: '140px',
    }),
    todayHeader: cxs({
        backgroundColor: '#e3f2fd',
    }),
    weekendHeader: cxs({
        backgroundColor: '#fff3e0',
    }),
    dayName: cxs({
        display: 'block',
        fontSize: '0.75rem',
        color: '#6c757d',
        textTransform: 'uppercase',
    }),
    dayNumber: cxs({
        display: 'block',
        fontSize: '1rem',
        fontWeight: 600,
    }),
};
var CalendarGrid = /** @class */ (function (_super) {
    __extends(CalendarGrid, _super);
    function CalendarGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarGrid.prototype.render = function () {
        var store = this.props.store;
        var today = moment().format('YYYY-MM-DD');
        console.log('CalendarGrid - store.dateRange: ', store.dateRange);
        return (React.createElement("div", { className: styles.container },
            React.createElement("table", { className: styles.table },
                React.createElement("thead", null,
                    React.createElement("tr", { className: styles.headerRow },
                        React.createElement("th", { className: styles.experienceHeader }, "Experiencia"),
                        store.dateRange.map(function (date) {
                            var dateStr = date.format('YYYY-MM-DD');
                            var isToday = dateStr === today;
                            var isWeekend = date.day() === 0 || date.day() === 6;
                            var headerClass = styles.dayHeader;
                            if (isToday) {
                                headerClass = "".concat(styles.dayHeader, " ").concat(styles.todayHeader);
                            }
                            else if (isWeekend) {
                                headerClass = "".concat(styles.dayHeader, " ").concat(styles.weekendHeader);
                            }
                            return (React.createElement("th", { key: dateStr, className: headerClass },
                                React.createElement("span", { className: styles.dayName }, date.format('ddd')),
                                React.createElement("span", { className: styles.dayNumber }, date.format('D/M'))));
                        }))),
                React.createElement("tbody", null, store.experiences.map(function (experience) {
                    // console.log('experience: ', experience)
                    var slotsByExperience = store.slotsByExperience[experience.id] || {};
                    console.log('slotsByExperience: ', slotsByExperience);
                    return (React.createElement(StretchRow, { key: experience.id, experience: experience, dateRange: store.dateRange, slotsByDate: slotsByExperience, onSlotClick: function (slot) { return store.openSlotDetail(slot); } }));
                })))));
    };
    CalendarGrid = __decorate([
        observer
    ], CalendarGrid);
    return CalendarGrid;
}(Component));
export default CalendarGrid;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/CalendarGrid.tsx
// module id = 1609
// module chunks = 0